import axiosInstance from "./api/axiosInstance"; // A instância do cliente

const BASE_ROUTE = `/communications`;

const messageService = {
  /**
   * Busca as mensagens destinadas ao cliente logado.
   */
  getMyMessages: async () => {
    try {
      const response = await axiosInstance.get(`${BASE_ROUTE}/my-messages`);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar minhas mensagens:", error);
      // Retorna array vazio em caso de erro para não quebrar a UI
      return [];
    }
  },
};

export default messageService;
